import useCfTrace from "./queries/useCfTrace";

const allowedCountries = ["DE", "DEU", "CH", "CHE", "AT", "AUT"];

export default function useGeoLivestream() {
  // TODO: what about the ping here?
  const { data: traceData } = useCfTrace();

  let livestreamAvailable = false;
  if (traceData) {
    livestreamAvailable = allowedCountries.includes(traceData.loc);
  }

  return {
    livestreamAvailable,
  };
}
